let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jxvAw")).then(() => parcelRequire('21nCU'));